<template>
  <BaseFormLayout
    :disableProgressBar="disableProgress"
    :steps="steps"
    :class="[pageClassName]"
    :step="stepNumber"
    :errorMessage="error"
    :loading="!!loading"
    :back="onPrevious.bind(this)"
    :formClasses="formClasses"
    :logoLinkName="logoLinkName"
    :logoAffinity="logoAffinity"
    :info="info"
    @errorPageReload="$emit('errorPageReload')"
    @errorPageClickGoHome="$emit('errorPageClickGoHome')"
    @errorPageClickWhatsApp="$emit('errorPageClickWhatsApp')"
    @errorPageClickCallUs="$emit('errorPageClickCallUs')"
    @clickLogo="$emit('clickLogo')"
    @clickPlan="$emit('clickPlan')"
    :excluded-countries="excludedCountries"
  >
      <slot  v-bind="{ component, name, events, props }"></slot>
      <template v-if="$slots['logo-first-line']" #logo-first-line>
        <slot name="logo-first-line"></slot>
      </template>

      <template v-if="$slots['logo-second-line']" #logo-second-line>
        <slot name="logo-second-line"></slot>
      </template>
      <template v-if="$slots['privacy-policy']" #privacy-policy>
        <slot name="privacy-policy"></slot>
      </template>
      <template v-if="$slots['loading-post-content']" #loading-post-content>
        <slot name="loading-post-content"></slot>
      </template>
  </BaseFormLayout>
</template>

<script>
import BaseFormLayout from './BaseFormLayout.vue'
export default {
  name: 'WizardStep',
  components: {
    BaseFormLayout
  },
  props: [
    'context',
    'page',
    'logoLinkName',
    'logoAffinity',
    'excludedCountries'
  ],
  data () {
    return {
      loading: 0,
      error: null,
      step: { }
    }
  },
  computed: {
    locale () {
      return this.$i18n.locale
    },
    component () {
      return this.step?.component
    },
    pageClassName () {
      return this.appName + '-' + this.name
    },
    appName () {
      return this.context?.appName
    },
    name () {
      return this.step?.name
    },
    disableProgress () {
      return this.step?.disableProgress || false
    },
    info () {
      return this.step?.info || false
    },
    formClasses () {
      return this.step?.formClasses || []
    },
    events () {
      return {
        ...(this.step?.events || {}),
        next: this.onNext,
        previous: this.onPrevious,
        error: this.onError,
        loading: this.onLoading
      }
    },
    props () {
      return {
        ...(this.step?.props || {})
      }
    },
    stepNumber () {
      return this.context.stepNumber
    },
    steps () {
      return this.context.stepCount
    }
  },
  methods: {
    load (promise) {
      this.loading++
      return promise
        .finally(() => {
          setTimeout(() => {
            this.loading--
          }, 100)
        })
    },
    onNext (params) {
      let next = null
      if (this.step.next) {
        next = typeof this.step.next === 'string' ? this.step.next : this.step.next(params)
      }
      if (next) {
        if (next.then) {
          this.load(next.then((next) => this.emitNext(next)))
        } else {
          this.emitNext(next, params)
        }
      }
    },
    onPrevious () {
      this.emitPrevious()
    },
    onError (error) {
      this.$emit('error')
      this.error = error
    },
    onLoading (state) {
      if (state) {
        this.loading++
      } else {
        this.loading--
      }
    },
    emitNext (next, params) {
      this.$emit('next', { next, ...params })
    },
    emitPrevious () {
      this.error = ''
      this.$emit('previous')
    },
    reloadStep () {
      this.loading = 0
      this.step = { }
      const initStep = this.context.initStep ? this.context.initStep(this.page) : null
      if (initStep) {
        if (initStep.then) {
          this.load(initStep)
            .then((step) => {
              this.step = step
              this.error = ''
            })
        } else {
          this.step = initStep
          this.error = ''
        }
      }
    }
  },
  mounted () {
    this.reloadStep()
  },
  watch: {
    page () {
      this.reloadStep()
    }
  }
}
</script>
